import { Flex } from 'antd';
import { Button } from '@common-web';
import { convertQueryObjToString, showResetButton } from '../helper';
import styles from './index.module.scss';
import cx from 'clsx';
import RenderFilter from '../render-filter';
import { searchFilterClickEvent } from '@ga-events';

const AdvancedFilters = ({
  location = {},
  navigate = () => {},
  setFiltersSidebarOpen = () => {},
  baseList = [],
  filtersObject = {},
  setFiltersObject = () => {},
  setSelectedVal = () => {},
  pageNumber = 1,
  setPageNumber = () => {},
  handleFiltersChange = () => {},
}) => {
  const applyFilters = () => {
    navigate({
      pathname: location.pathname,
      search: convertQueryObjToString({ ...filtersObject, page: 1 }),
    });

    setFiltersSidebarOpen(false);
  };

  const resetFilters = () => {
    navigate({
      pathname: location.pathname,
      search: '',
    });
    setFiltersSidebarOpen(false);
  };

  return (
    <Flex vertical style={{ minHeight: '100%' }}>
      {baseList.length > 0 ? (
        <>
          <Flex vertical gap={24} className={cx(styles.advanceFilters, 'flexGrow')}>
            {baseList?.length &&
              baseList?.map((item, index) => {
                return (
                  <RenderFilter
                    key={item?.key}
                    item={item}
                    filtersObject={filtersObject}
                    setFiltersObject={setFiltersObject}
                    baseList={baseList}
                    setSelectedVal={setSelectedVal}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    handleFiltersChange={handleFiltersChange}
                  />
                );
              })}
          </Flex>
          <Flex align="center" justify="end" gap={8} className={styles.buttons}>
            {showResetButton(location) && <Button text={'Reset Filters'} onClick={resetFilters} />}
            <Button text={'Apply Filters'} type="primary"
              onClick={() => {
                applyFilters();
                searchFilterClickEvent(filtersObject);
              }} />
          </Flex>
        </>
      ) : (
        'EMPTY STATE'
      )}
    </Flex>
  );
};

export default AdvancedFilters;
